'use client';

import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';

export function ProductBottomInfo() {
  const { t } = useTranslations();

  const product = useVariantsStore(state => state.product);

  return (
    <div className="flex w-full flex-wrap items-start justify-start gap-4 sm:gap-6">
      {product?.categories && product?.categories.length > 0 && (
        <div className="flex items-center justify-start gap-2">
          <Paragraph size="sm" color="neutral">
            {t('text230')}
          </Paragraph>
          <span className="flex h-[26px] items-center justify-center rounded-[8px] border px-[10px] text-xs font-medium text-foreground sm:text-sm">
            {product?.categories[0]?.name}
          </span>
        </div>
      )}
      {product?.manufacturers && product?.manufacturers.length > 0 && (
        <div className="flex items-center justify-start gap-2">
          <Paragraph size="sm" color="neutral">
            {t('text175')}:
          </Paragraph>
          <span className="flex h-[26px] items-center justify-center rounded-[8px] border px-[10px] text-xs font-medium text-foreground sm:text-sm">
            {product?.manufacturers[0]?.name}
          </span>
        </div>
      )}
    </div>
  );
}
